export default {
    meta: {
        title: '拓店宝-选择场地'
    }
};
